// The hike page's "N warnings on route" section (app/views/hikes/show.html.erb
// renders the empty mount point under the stats row). Mounted after the page
// has loaded; the warnings are fetched in the browser, so the server-rendered
// page and its caching are untouched.
import { createApp } from 'vue';
import { i18n } from '../../i18n';
import HikeRouteWarnings from './HikeRouteWarnings.vue';
import { MeasurementPrefUtility } from '../../utils/helpers/MeasurementPref';
import { shouldOpenWarnings } from '../../utils/routeAlerts/warningsLink';

function mountRouteWarnings(): void {
  const el = document.querySelector<HTMLElement>('[data-route-warnings]');
  const hikeId = el?.dataset.hikeId;
  if (!el || !hikeId) return;

  let metric = true;
  try {
    metric = MeasurementPrefUtility.preference().isMetric();
  } catch {
    // Default to km, as the page's own stats do for a signed-out visitor.
  }

  // The count the server drew the folded box with (none: it couldn't work one out).
  const drawn = Number.parseInt(el.dataset.count ?? '', 10);

  createApp(HikeRouteWarnings, {
    hikeId,
    mapUrl: el.dataset.mapUrl || null,
    initialCount: Number.isFinite(drawn) ? drawn : null,
    metric,
    openOnLoad: shouldOpenWarnings(window.location.hash, window.location.search),
  }).use(i18n).mount(el);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountRouteWarnings, { once: true });
} else {
  mountRouteWarnings();
}
